var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1047 1080",
    style: {
      enableBackground: "new 0 0 1047 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{fill:url(#SVGID_2_);}\r\n\t.st2{fill:url(#SVGID_3_);}\r\n\t.st3{fill:url(#SVGID_4_);}\r\n\t.st4{fill:url(#SVGID_5_);}\r\n\t.st5{fill:url(#SVGID_6_);}\r\n\t.st6{fill:url(#SVGID_7_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 268.1832,
    y1: 471.0653,
    x2: 759.7917,
    y2: 471.0653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2002,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4706,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7798,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M741.98,455.13c-36.18,15.48-72.78,29.57-111.61,37.18c-101.32,19.86-194.8,1.9-279.74-57.55 c-4.78-3.34-11.35-5.65-8.46-14.52c4.04-12.42-4.11-15.3-13.46-12.68c-23.13,6.48-40.7,21.95-56.92,38.81 c-4.79,4.99-4.77,11.85-0.19,17.42c4.46,5.43,10.55,6.28,17.2,4.17c6.2-1.97,11.28-5.83,15.85-10.09 c5.63-5.25,9.56-5.02,15.96-0.14c61.14,46.57,130.18,72.68,206.97,77.1c77.26,4.44,148.16-14.55,211.23-60.17 c8.11-5.87,16.73-11.75,20.97-22.81C752.1,449.06,747.08,452.96,741.98,455.13z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 588.7357,
    y1: 918.6552,
    x2: 773.8405,
    y2: 918.6552
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1489,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3501,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8326,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0D4982"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M599.41,919.85c16.14-15.71,35.98-20.56,55.86-24.9c32.14-6.92,64.9-8.9,97.12-17.04v-0.07 c7.18-1.83,14.32-3.87,21.45-6.53c-9.08,15.1-22.78,21.74-36.05,29.06c-1.79,0.97-3.48,1.9-5.24,2.87 c-14.74,8.29-29.38,16.79-41.9,29.71c-12.84,13.27-21.49,22.17-28.88,27.37c-16.18,11.44-25.87,4.81-60.27-12.81 c-16.47-8.36-16.68-13.2-2.44-27.23L599.41,919.85z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 567.6263,
    y1: 839.1476,
    x2: 803.5449,
    y2: 839.1476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1489,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3501,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8326,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M583.45,857.03c3.23-2.94,6.64-5.31,10.12-7.57c15.82-10.05,33.11-15.03,50.62-18.8 c2.12-0.5,4.13-0.93,6.24-1.36c21.35-4.27,42.84-6.92,64.5-10.22c27.95-4.2,56.15-9.26,84.42-19.73c1.4-0.47,2.8-0.97,4.2-1.51 c-3.66,6.13-7.5,11.3-11.59,15.75c-7.68,8.47-16.18,14.28-25.33,19.09c-22.64,11.91-46.82,15.89-71.07,19.34 c-0.97,0.14-1.87,0.32-2.91,0.43c-9.08,1.29-18.23,2.33-27.34,3.41c-25.76,3.19-51.73,6.6-77.85,16.14 c-6.57,2.37-13.27,5.17-19.84,8.47C571.82,869.62,577.31,862.45,583.45,857.03z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 557.6886,
    y1: 704.3441,
    x2: 854.4542,
    y2: 704.3441
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1489,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3501,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8326,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M588.58,724c2.8-1.44,5.6-2.83,8.47-4.13c15.21-7,31.03-11.41,47.07-15.28 c44.45-10.66,89.83-15.46,134.82-25.58c25.33-5.67,50.55-13.02,75.52-24.11c-7.36,13.38-15.79,21.67-25.08,28.92 c-19.73,15.46-41.62,24.11-64.25,30.14c-4.7,1.29-9.4,2.44-14.06,3.48c-39.03,8.97-78.64,12.16-117.96,17.83 c-8.43,1.22-16.83,2.76-25.22,4.59c-16.39,3.52-32.9,8.22-50.19,13.92C566.08,738.03,576.88,730.28,588.58,724z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 563.6078,
    y1: 775.163,
    x2: 820.3354,
    y2: 775.163
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1489,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3501,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8326,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M588.94,787.9c11.01-7.35,22.78-12.2,34.91-15.79c6.06-1.83,12.23-3.34,18.44-4.74 c35.09-7.93,70.71-10.83,106.95-17.01c23.43-3.95,47.18-9.36,71.11-18.44c-15.89,24.29-33.62,35.27-53.35,42.58 c-11.12,4.05-22.35,7.03-33.72,9.29c-15.1,3.05-30.39,4.81-45.74,6.64c-17.29,2.15-34.69,3.8-52.13,6.53 c-21.31,3.41-42.69,8.47-64.11,17.9c-2.51,1.11-5.13,2.3-7.68,3.52c1.76-3.87,3.59-7.35,5.53-10.48 C574.95,798.66,581.51,792.81,588.94,787.9z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 123.4598,
    y1: 539.9319,
    x2: 735.0238,
    y2: 539.9319
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2002,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4706,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7798,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M421.47,756.9c-1.47,3.05-2.94,6.1-4.38,9.26c-10.12,21.49-19.8,43.23-30.17,64.54 c-4.23,8.83-10.22,18.69-20.02,19.87c-11.34,1.26-19.73-9.94-25.4-19.87c-48.79-85.52-88.12-179.35-111.95-275.89 c-22.98-93.11-39.33-201.37-16.16-295.86c5.45-22.36,15.91-46.98,37.82-54.05c14.16-4.54,29.7-0.27,43.52,5.35 c56.04,22.85,101.52,67.92,159.05,86.57c47.23,15.29,99.02,11.29,146.61-2.87c47.57-14.21,91.5-38.07,134.63-62.59 c-85.42,18.75-177.63,31.52-257.92-3.19c-39.91-17.23-74.15-45.19-111.61-67.28c-37.46-22.07-81.47-38.61-123.98-29.43 c-40.18,8.66-73.07,39.71-91.73,76.43c-28.52,56.14-28.31,123.24-24.57,184.6c6.89,112.98,42.92,220.57,86.55,324.22 c31.32,74.3,68.06,148.53,126.64,203.92c12.34,11.7,26.05,22.67,42.26,27.73c16.25,5.06,35.55,3.09,47.86-8.72 c10.23-9.87,13.96-24.47,17.29-38.24c17.18-70.57,35.91-141.6,70.1-205.71c21.13-39.75,51.81-74.05,90.01-89.33 C584.67,605.58,492.11,611.25,421.47,756.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 460.9123,
    y1: 407.8156,
    x2: 923.5402,
    y2: 407.8156
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1489,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3501,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5811,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8326,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#fff"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M918.84,393.3c-4.15,36.59-10.18,72.68-17.45,108.74c-10.14,50.27-34.45,99.49-78.51,128.14 c-53.82,35-125.54,32.46-186.64,43.37c-19.83,3.54-39.49,8.18-58.48,14.96c-10.21,3.68-20.35,7.89-30.35,13.11 c4.63-12.91,10.89-22.07,18.51-29.49c2.58-2.52,5.31-4.81,8.16-7c14.33-10.83,30.2-17.12,46.55-21.99 c42.61-12.67,86.34-15.9,129.42-24.06c0.18-0.03,0.33-0.06,0.5-0.09c31.21-5.96,56.16-29.49,63.91-60.29 c7.24-28.78,12.43-56.61,13.2-60.7c3.14-18.99,5.87-37.98,8.4-56.73c7.21-53.94,8.78-109.1,0.89-163.06 c-4.33-29.79-12.13-64.83-35.37-86.01c-25.43-23.2-60.59-15.49-88.71-1.69c-84.23,41.33-170.36,57-251.96-3.2 c1.42,0.33,24.03,6.23,24.06,6.23c41.12,10.77,83.91,1.57,122.42-14.54c50.08-21.04,93.76-58.27,149.62-63.85 C910.65,99.81,936.16,240.47,918.84,393.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.8d62ba8c082e1129b1101c9bdb86d4fd.svg";
export { ForwardRef as ReactComponent };